export function getAdminChartColors(isDark: boolean) {
  return {
    text: isDark ? "#e2e8f0" : "#374151",
    muted: isDark ? "#94a3b8" : "#6b7280",
    grid: isDark ? "#334155" : "#e5e7eb",
    title: isDark ? "#f8fafc" : "#1f2937",
  };
}
